// ご依頼主名義変更サービス 관련
(function () {
  var ROOT_SELECTOR = '#ec-proxy-sender';

  function getRoot() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function qs(root, selector) {
    if (!root) return null;
    return root.querySelector(selector);
  }

  function getDetails(root) {
    return qs(root, 'details');
  }

  function getChoiceBox(root) {
    return qs(root, '[data-ec-proxy-choice-box]');
  }

  function getChoiceError(root) {
    return qs(root, '[data-ec-proxy-choice-error]');
  }

  function getContinueBox(root) {
    return qs(root, '[data-ec-proxy-continue]');
  }

  function getBody(root) {
    return qs(root, '[data-ec-proxy-body]');
  }

  function getActions(root) {
    return qs(root, '.ec-proxy-actions');
  }

  function getFieldError(root) {
    return qs(root, '[data-ec-proxy-field-error]');
  }

  function getFields(root) {
    return {
      company: qs(root, 'input[name="proxy_sender_company"]'),
      post: qs(root, 'input[name="proxy_sender_post"]'),
      name: qs(root, 'input[name="proxy_sender_name"]'),
      phone: qs(root, 'input[name="proxy_sender_phone"]'),
      address: qs(root, 'input[name="proxy_sender_address"]')
    };
  }

  function trimValue(el) {
    return el && typeof el.value === 'string' ? el.value.trim() : '';
  }

  function digitsOnly(value) {
    return String(value || '').replace(/[^\d]/g, '');
  }

  function formatPostcode(value) {
    var d = digitsOnly(value).slice(0, 7);
    if (!d) return '';
    if (d.length <= 3) return d;
    return d.slice(0, 3) + '-' + d.slice(3);
  }

  function syncPostField(root) {
    var fields = getFields(root);
    if (!fields.post) return;
    fields.post.value = formatPostcode(fields.post.value);
  }

  function getPayload(root) {
    var fields = getFields(root);
    return {
      proxy_sender_company: trimValue(fields.company),
      proxy_sender_post: formatPostcode(trimValue(fields.post)),
      proxy_sender_name: trimValue(fields.name),
      proxy_sender_phone: trimValue(fields.phone),
      proxy_sender_address: trimValue(fields.address)
    };
  }

  function hasAnyValue(payload) {
    return !!(
      payload.proxy_sender_company ||
      payload.proxy_sender_post ||
      payload.proxy_sender_name ||
      payload.proxy_sender_phone ||
      payload.proxy_sender_address
    );
  }

  function buildSummaryValue(payload) {
    var c = (payload.proxy_sender_company || '').trim();
    var z = formatPostcode(payload.proxy_sender_post || '');
    var n = (payload.proxy_sender_name || '').trim();
    var p = (payload.proxy_sender_phone || '').trim();
    var a = (payload.proxy_sender_address || '').trim();

    if (!c && !z && !n && !p && !a) return '';

    var parts = [];
    if (n) parts.push('氏名=' + n);
    if (c) parts.push('会社名=' + c);
    if (z) parts.push('郵便番号=' + z);
    if (a) parts.push('住所=' + a);
    if (p) parts.push('電話番号=' + p);

    return parts.join(' | ');
  }

  function buildCartAttributes(payload) {
    return {
      proxy_sender_company: (payload.proxy_sender_company || '').trim(),
      proxy_sender_name: (payload.proxy_sender_name || '').trim(),
      proxy_sender_post: formatPostcode(payload.proxy_sender_post || ''),
      proxy_sender_address: (payload.proxy_sender_address || '').trim(),
      proxy_sender_phone: (payload.proxy_sender_phone || '').trim(),
      'ご依頼主名義変更': buildSummaryValue(payload)
    };
  }

  function buildEmptyCartAttributes() {
    return {
      proxy_sender_company: '',
      proxy_sender_name: '',
      proxy_sender_post: '',
      proxy_sender_address: '',
      proxy_sender_phone: '',
      'ご依頼主名義変更': ''
    };
  }

  function setChoice(root, value) {
    root.dataset.ecProxyChoice = value || '';
  }

  function getChoice(root) {
    return root.dataset.ecProxyChoice || '';
  }

  function setSavedSnapshot(root, payload) {
    root.dataset.ecProxySaved = JSON.stringify(payload || {});
  }

  function getSavedSnapshot(root) {
    try {
      return JSON.parse(root.dataset.ecProxySaved || '{}');
    } catch (err) {
      return {};
    }
  }

  function hasSavedSnapshot(root) {
    return hasAnyValue(getSavedSnapshot(root));
  }

  function isDirty(root) {
    var current = getPayload(root);
    var saved = getSavedSnapshot(root);

    return (
      (current.proxy_sender_company || '') !== (saved.proxy_sender_company || '') ||
      (current.proxy_sender_post || '') !== (saved.proxy_sender_post || '') ||
      (current.proxy_sender_name || '') !== (saved.proxy_sender_name || '') ||
      (current.proxy_sender_phone || '') !== (saved.proxy_sender_phone || '') ||
      (current.proxy_sender_address || '') !== (saved.proxy_sender_address || '')
    );
  }

  function setChoiceError(root, message) {
    var el = getChoiceError(root);
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function setFieldError(root, message) {
    var el = getFieldError(root);
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function clearFields(root) {
    var fields = getFields(root);
    if (fields.company) fields.company.value = '';
    if (fields.post) fields.post.value = '';
    if (fields.name) fields.name.value = '';
    if (fields.phone) fields.phone.value = '';
    if (fields.address) fields.address.value = '';
  }

  function setContinuePending(root, flag) {
    root.dataset.ecProxyContinuePending = flag ? '1' : '0';
  }

  function isContinuePending(root) {
    return root.dataset.ecProxyContinuePending === '1';
  }

  function updateUI(root) {
    if (!root) return;

    var choiceBox = getChoiceBox(root);
    var continueBox = getContinueBox(root);
    var body = getBody(root);
    var actions = getActions(root);
    var choice = getChoice(root);
    var payload = getPayload(root);
    var continuePending = isContinuePending(root);

    if (choice !== 'yes') {
      if (choiceBox) choiceBox.hidden = false;
      if (continueBox) continueBox.hidden = true;
      if (body) body.hidden = true;
      if (actions) actions.hidden = true;
      setFieldError(root, '');
      return;
    }

    if (choiceBox) choiceBox.hidden = true;
    if (body) body.hidden = false;

    if (continueBox) continueBox.hidden = !continuePending;

    if (!hasAnyValue(payload)) {
      if (actions) actions.hidden = true;
      setFieldError(root, '');
      return;
    }

    if (actions) actions.hidden = continuePending || !isDirty(root);
  }

  function openIfHashMatched(root) {
    if (location.hash !== '#ec-proxy-sender') return;
    var details = getDetails(root);
    if (details) details.open = true;
  }

  function bindDetailsToggle(root) {
    var details = getDetails(root);
    if (!details) return;
    if (details.dataset.ecProxyToggleBound === '1') return;

    details.dataset.ecProxyToggleBound = '1';

    details.addEventListener('toggle', function () {
      setChoiceError(root, '');
      setFieldError(root, '');

      setChoice(root, '');
      setContinuePending(root, false);
      updateUI(root);
    });
  }

  function initialize() {
    var root = getRoot();
    if (!root) return;

    syncPostField(root);

    setSavedSnapshot(root, getPayload(root));
    setChoice(root, '');
    setContinuePending(root, false);
    setChoiceError(root, '');
    setFieldError(root, '');

    bindDetailsToggle(root);

    updateUI(root);
    openIfHashMatched(root);
  }

  function validateProxySender(root) {
    var payload = getPayload(root);
    var fields = getFields(root);
    var details = getDetails(root);

    if (details) details.open = true;
    if (getBody(root)) getBody(root).hidden = false;

    if (!hasAnyValue(payload)) {
      setFieldError(root, 'ご依頼主名義（差出人）情報を入力してください。');
      if (fields.company) fields.company.focus();
      return false;
    }

    if (!payload.proxy_sender_company) {
      setFieldError(root, '会社名は必須です。');
      if (fields.company) fields.company.focus();
      return false;
    }

    if (!payload.proxy_sender_name) {
      setFieldError(root, '氏名は必須です。');
      if (fields.name) fields.name.focus();
      return false;
    }

    if (!payload.proxy_sender_post) {
      setFieldError(root, '郵便番号は必須です。');
      if (fields.post) fields.post.focus();
      return false;
    }

    if (digitsOnly(payload.proxy_sender_post).length !== 7) {
      setFieldError(root, '郵便番号は7桁で入力してください。');
      if (fields.post) fields.post.focus();
      return false;
    }

    if (!payload.proxy_sender_address) {
      setFieldError(root, '住所は必須です。');
      if (fields.address) fields.address.focus();
      return false;
    }

    if (!payload.proxy_sender_phone) {
      setFieldError(root, '電話番号は必須です。');
      if (fields.phone) fields.phone.focus();
      return false;
    }

    if (fields.post) {
      fields.post.value = payload.proxy_sender_post;
    }

    setFieldError(root, '');
    setChoiceError(root, '');
    return true;
  }

  async function persistProxySender(root) {
    var payload = getPayload(root);

    if (!validateProxySender(root)) {
      return false;
    }

    var response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: buildCartAttributes(payload)
      })
    });

    if (!response.ok) {
      throw new Error('cart/update failed');
    }

    setSavedSnapshot(root, payload);
    setChoice(root, 'yes');
    setContinuePending(root, false);
    setChoiceError(root, '');
    setFieldError(root, '');
    updateUI(root);

    return true;
  }

  async function saveProxySender(root, button) {
    var originalText = button ? button.textContent : '';

    if (button) button.disabled = true;

    try {
      var saved = await persistProxySender(root);
      if (!saved) return false;

      if (button) {
        button.textContent = '保存しました';
        setTimeout(function () {
          button.textContent = originalText;
        }, 900);
      }

      return true;
    } catch (err) {
      console.error(err);
      setFieldError(root, '保存に失敗しました。時間をおいて再度お試しください。');
      return false;
    } finally {
      if (button) button.disabled = false;
    }
  }

  async function chooseNo(root) {
    try {
      var response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: buildEmptyCartAttributes()
        })
      });

      if (!response.ok) {
        throw new Error('cart/update failed');
      }

      clearFields(root);
      setSavedSnapshot(root, {
        proxy_sender_company: '',
        proxy_sender_post: '',
        proxy_sender_name: '',
        proxy_sender_phone: '',
        proxy_sender_address: ''
      });
      setChoice(root, '');
      setContinuePending(root, false);
      setChoiceError(root, '');
      setFieldError(root, '');
      updateUI(root);

      var details = getDetails(root);
      if (details) details.open = false;
    } catch (err) {
      console.error(err);
      alert('削除に失敗しました。時間をおいて再度お試しください。');
    }
  }

  function chooseYes(root) {
    setChoice(root, 'yes');
    setChoiceError(root, '');
    setFieldError(root, '');

    setContinuePending(root, hasAnyValue(getPayload(root)));
    updateUI(root);

    var details = getDetails(root);
    if (details) details.open = true;
  }

  async function useSaved(root, button) {
    if (!validateProxySender(root)) {
      return false;
    }

    if (!isDirty(root) && hasSavedSnapshot(root)) {
      setChoice(root, 'yes');
      setContinuePending(root, false);
      setChoiceError(root, '');
      setFieldError(root, '');
      updateUI(root);
      return true;
    }

    return await saveProxySender(root, button);
  }

  async function clearAndReenter(root) {
    try {
      var response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: buildEmptyCartAttributes()
        })
      });

      if (!response.ok) {
        throw new Error('cart/update failed');
      }

      clearFields(root);
      setSavedSnapshot(root, {
        proxy_sender_company: '',
        proxy_sender_post: '',
        proxy_sender_name: '',
        proxy_sender_phone: '',
        proxy_sender_address: ''
      });
      setChoice(root, 'yes');
      setContinuePending(root, false);
      setChoiceError(root, '');
      setFieldError(root, '');
      updateUI(root);

      var details = getDetails(root);
      if (details) details.open = true;
    } catch (err) {
      console.error(err);
      alert('削除に失敗しました。時間をおいて再度お試しください。');
    }
  }

  async function ensureSavedBeforeCheckout(root) {
    if (!root) return true;

    if (getChoice(root) !== 'yes') {
      return true;
    }

    try {
      return await persistProxySender(root);
    } catch (err) {
      console.error(err);
      setFieldError(root, '保存に失敗しました。時間をおいて再度お試しください。');
      return false;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initialize();
  });

  document.addEventListener('input', function (e) {
    var root = getRoot();
    if (!root || !root.contains(e.target)) return;

    if (e.target && e.target.name === 'proxy_sender_post') {
      e.target.value = formatPostcode(e.target.value);
    }

    if (getChoice(root) !== 'yes') return;

    setChoiceError(root, '');
    setFieldError(root, '');

    setContinuePending(root, hasAnyValue(getPayload(root)));
    updateUI(root);
  });

  document.addEventListener('click', function (e) {
    var root = getRoot();
    if (!root) return;

    var yesBtn = e.target.closest('[data-ec-proxy-choice-yes]');
    if (yesBtn) {
      chooseYes(root);
      return;
    }

    var noBtn = e.target.closest('[data-ec-proxy-choice-no]');
    if (noBtn) {
      chooseNo(root);
      return;
    }

    var keepBtn = e.target.closest('[data-ec-proxy-keep]');
    if (keepBtn) {
      useSaved(root, keepBtn);
      return;
    }

    var clearBtn = e.target.closest('[data-ec-proxy-clear]');
    if (clearBtn) {
      clearAndReenter(root);
      return;
    }

    var saveBtn = e.target.closest('[data-ec-proxy-save]');
    if (saveBtn) {
      saveProxySender(root, saveBtn);
      return;
    }
  });

  function setCheckoutInProgress(root, flag) {
    if (!root) return;
    root.dataset.ecProxyCheckoutInProgress = flag ? '1' : '0';
  }

  function isCheckoutInProgress(root) {
    return !!(root && root.dataset.ecProxyCheckoutInProgress === '1');
  }

  document.addEventListener('click', function (e) {
    var checkoutBtn = e.target.closest('button[name="checkout"], #CartDrawer-Checkout');
    if (!checkoutBtn) return;

    var root = getRoot();
    if (!root) return;
    if (isCheckoutInProgress(root)) return;

    e.preventDefault();
    e.stopPropagation();

    (async function () {
      setCheckoutInProgress(root, true);
      try { checkoutBtn.disabled = true; } catch (_) {}

      var canCheckout = await ensureSavedBeforeCheckout(root);
      if (!canCheckout) {
        setCheckoutInProgress(root, false);
        try { checkoutBtn.disabled = false; } catch (_) {}
        return;
      }

      window.location.href = '/checkout';
    })();
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form) return;
    if (form.id !== 'cart' && form.id !== 'CartDrawer-Form') return;

    var root = getRoot();
    if (!root) return;
    if (isCheckoutInProgress(root)) return;

    e.preventDefault();
    e.stopPropagation();

    (async function () {
      setCheckoutInProgress(root, true);

      var canCheckout = await ensureSavedBeforeCheckout(root);
      if (!canCheckout) {
        setCheckoutInProgress(root, false);
        return;
      }

      window.location.href = '/checkout';
    })();
  }, true);
})();